import React from "react";
import StaticPage from "../components/StaticPage";

export default function AboutUs() {
    return (
        <StaticPage
            kicker="About"
            title="We're building the ownership layer of cinema."
            lede="Silver Screen Xchange was founded by a team of filmmakers, IP lawyers and marketplace builders to bring transparency, legal precision and global reach to the transfer of film copyright."
            blocks={[
                { eyebrow: "Mission", title: "Move rights cleanly",
                  body: "Creators deserve to get paid once, worldwide. Buyers deserve clean title. We're building the rails that make both possible — publicly, legally and at internet speed." },
                { eyebrow: "Jurisdiction", title: "Indian Copyright Act, 1957",
                  body: "Every contract on the platform is written to Sections 14 and 18, with exclusive Indian jurisdiction — the same legal spine that protects Indian cinematic works since 1957." },
                { eyebrow: "Team", title: "Cinema + law + product",
                  body: "Backgrounds from Bollywood production, A24-style indie distribution, Mumbai IP chambers, and global marketplaces. We sit at the intersection, on purpose." },
                { eyebrow: "Culture", title: "Slow decisions, fast execution",
                  body: "We think carefully about what a registry means for a hundred years, and we ship product every week. Both matter." },
            ]}
            cta={{ label: "Talk to us", href: "/contact" }}
        />
    );
}
